import React from 'react';

const Footer = () => {
  return <div className='footer'>Phoenix Chang 2022©</div>;
};

export default Footer;
